import { AfterViewInit, Component, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { take } from 'rxjs'
import { UsersService } from './shared/pages/settings/services/users.service'
import { CurrentDeviceService } from './shared/services/current-device.service'
import { UpdateService } from './shared/services/update.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'yabi'
  myForm: FormGroup
  constructor(private userService: UsersService, private translate: TranslateService, public currentDeviceService: CurrentDeviceService, private updateService: UpdateService) {
    this.initLang()
  }
  initLang() {
    // this language will be used as a fallback when a translation isn't found in the current language
    if (this.currentDeviceService && this.currentDeviceService.isMobile) this.translate.setDefaultLang('en')

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use('en')

    if (localStorage.getItem('JWT_STR')) {
      this.userService
        .getCurrentUserPrefs()
        .pipe(take(1))
        .subscribe((data) => {
          if (data.language) {
            this.translate.use(data.language)
            const dir = data.language === 'he' ? 'rtl' : 'ltr'
            document.dir = dir
          }
        })
    } else {
      this.translate.use(navigator.language.split('-')[0])
    }
  }
  ngAfterViewInit() {
    const dir = this.translate.currentLang.toLowerCase() === 'he' ? 'rtl' : 'ltr'
    document.dir = dir
    if (this.currentDeviceService && this.currentDeviceService.isMobile) {
      document.getElementById('htmlTag')!.style.overflow = 'hidden'
      document.getElementById('bodyTag')!.style.overflow = 'hidden'
      document.getElementById('bodyTag')!.style.minWidth = 'unset'
    }
  }

  ngOnInit() {
    // Start checking for updates
    this.updateService.checkForUpdates()

    // Expose update service for debugging in production
    this.updateService.exposeToWindow()

    window.dispatchEvent(new CustomEvent('yabi-ready'))
  }
}
